import { Suspense, useState } from 'react';
import {
  CircularProgress,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useUser } from 'reactfire';

import { MainContent } from '../styled/ChatPage.styled';
import { LoaderContainer } from '../styled/App.styled';
import Sidebar from './chat/sidebar/Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const theme = useTheme();
  const user = useUser();

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [isSidebarOpen, setIsSidebarOpen] = useState(
    () => !!user.data && isDesktop,
  );

  return (
    <Stack flexDirection="row">
      <Sidebar open={isSidebarOpen} onOpen={setIsSidebarOpen} />
      <MainContent open={isSidebarOpen}>
        <Suspense
          fallback={
            <LoaderContainer>
              <CircularProgress />
            </LoaderContainer>
          }
        >
          {children}
        </Suspense>
      </MainContent>
    </Stack>
  );
};

export default Layout;
